import { render, staticRenderFns } from "./WorkHeavyEquipment.vue?vue&type=template&id=3994e4e8&scoped=true"
import script from "./WorkHeavyEquipment.vue?vue&type=script&lang=js"
export * from "./WorkHeavyEquipment.vue?vue&type=script&lang=js"
import style0 from "./WorkHeavyEquipment.vue?vue&type=style&index=0&id=3994e4e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3994e4e8",
  null
  
)

export default component.exports